<template>
  <div id="recommended-list">
    <p class="has-font-weight-bold">Recommended</p>
    <ul class="row list-unstyle has-mt-0">
      <template v-for="(item, index) in recommendeds">
        <li v-if="index < 4" :key="`recommended-${index}`" class="col-sm-6 col-md-6 has-mb-4 filter-item">
          <RecommendedCard
              :heading="item.heading"
              :image="item.image"
              :text="item.text"
              :link="item.headingHref"
              :tags="item.tags"
              :icon="item.icon"
              :category="item.category"
              :categoryRank="item.categoryRankSortable"
              :importance="item.importanceSortable" />
        </li>

        <li v-else :key="`recommended-${index}`" class="col-sm-6 col-md-6 has-mb-4 filter-item">
          <RecommendedText
            :heading="item.heading"            
            :text="item.text"
            :link="item.headingHref"
            :category="item.category"
            :categoryRank="item.categoryRankSortable"
            :importance="item.importanceSortable" />
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import RecommendedCard from "./RecommendedCard";
import RecommendedText from "./RecommendedText";

export default {
  name: "Recommended",
  components: {
    RecommendedCard,
    RecommendedText
  },
  computed: {
    recommendeds: function () {
      return this.$store.state.recommended;
    },
  },
}
</script>